'use client';

import type {AddressSummaryProps as Props} from './typings';

import {StyledAddressSummary} from './styles';
import {getAddressDisplay} from './utils';

/**
 * @description Show address summary for shipping estimate
 * in format "City, Country (Variant)".
 * Eg., "Berlin, DE (origin)".
 * @param {Props} props - component props.
 * @param {Object} props.location - The location object.
 * @param {string|null} props.location.city - The city name.
 * @returns {JSX.Element|null} The rendered address summary or `null` if no content is available.
 */
const AddressSummary = ({location, variant, ...restParagraphProps}: Props): JSX.Element | null => {
  const displayContent = getAddressDisplay(location);

  return displayContent ? (
    <StyledAddressSummary {...restParagraphProps}>
      <b>{displayContent}</b> <small>{`(${variant})`}</small>
    </StyledAddressSummary>
  ) : null;
};

export default AddressSummary;
